// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"363":"0abac488ba19629c9da3","695":"6109f424725eda6c747d"}[chunkId] + ".css";
};